import { create } from "zustand";

interface ReactRenderStore {
  prompt: string;
  setPrompt: (prompt: string) => void;
  loading: boolean;
  setLoading: (loading: boolean) => void;
  chatId: string | null;
  setChatId: (chatId: string) => void;

  selectedElement: {
    id: string;
    class: string;
    text: string;
    style: string;
    tagName: string;
  } | null;
  setSelectedElement: (
    selectedElement: {
      id: string;
      class: string;
      text: string;
      style: string;
      tagName: string;
    } | null,
  ) => void;

  editText: string | null;
  setEditText: (editText: string | null) => void;

  displayMode: "preview" | "edit";
  setDisplayMode: (displayMode: "preview" | "edit") => void;
}

export const useReactRenderStore = create<ReactRenderStore>((set) => ({
  chatId: null,
  setChatId: (chatId) => set({ chatId }),

  prompt: "",
  setPrompt: (prompt) => set({ prompt }),

  loading: false,
  setLoading: (loading) => set({ loading }),

  selectedElement: null,
  setSelectedElement: (selectedElement) => set({ selectedElement }),

  editText: null,
  setEditText: (editText) => set({ editText }),

  displayMode: "preview",
  setDisplayMode: (displayMode) => set({ displayMode }),
}));
